import API_ENDPOINTS from '@/apis/api-endpoints';
import { adminAuthAxios, pureAxios } from '@/apis/axios';

import type {
  BoardContentDetail,
  BoardContentUpdateType,
} from '@/types/boardContent';

import type {
  BoardContentsDetailParamsType,
  BoardContentsParamsType,
  BoardContentsType,
} from './types';

/**
 * 게시글 리스트 API 호출
 */
export const getBoardContentsByBdId = async ({
  bd_id,
  take,
  page,
  order,
  search,
  category,
}: Partial<BoardContentsParamsType>): Promise<BoardContentsType> => {
  const params = { bd_id, take, page, order, search, category };
  const res = await pureAxios.get(`${API_ENDPOINTS.BOARD_CONTENTS}`, {
    params,
  });
  return res.data.data;
};

/**
 * 게시글 상세 API 호출
 */
export const getBoardContentsDetailByBcidx = async ({
  bc_idx,
  recently,
}: Partial<BoardContentsDetailParamsType>): Promise<BoardContentDetail> => {
  const params = { recently };

  const res = await pureAxios.get(`${API_ENDPOINTS.BOARD_CONTENTS}/${bc_idx}`, {
    params,
  });
  return res.data.data;
};

/**
 * POST
 * /board-contents
 * 게시글 생성 API (비회원)
 */
export const createNonUserBoardContent = async (
  body: BoardContentUpdateType,
) => {
  const res = await pureAxios.post(
    `${API_ENDPOINTS.BOARD_CONTENTS}/nonuser`,
    body,
  );
  const resData = res.data;

  if (!resData.success) {
    throw resData;
  }

  return resData;
};

/**
 * POST
 * /board-contents
 * 게시글 생성 API (관리자)
 */
export const createAdminBoardContent = async (body: BoardContentUpdateType) => {
  const res = await adminAuthAxios.post(
    `${API_ENDPOINTS.BOARD_CONTENTS}`,
    body,
  );

  const resData = res.data;

  if (!resData.success) {
    throw resData;
  }

  return resData;
};

/**
 * PATCH
 * /board-contents/{bc_idx}
 * 게시글 수정 API
 */
export const updateBoardContent = async ({
  bc_idx,
  body,
}: {
  bc_idx: string;
  body: BoardContentUpdateType;
}) => {
  const res = await adminAuthAxios.patch(
    `${API_ENDPOINTS.BOARD_CONTENTS}/${bc_idx}`,
    body,
  );
  return res.data.data;
};

/**
 * DELETE
 * /board-contents/{bc_idx}
 * 게시글 삭제 API
 */
export const deleteBoardContent = async (bc_idx: string) => {
  const res = await adminAuthAxios.delete(
    `${API_ENDPOINTS.BOARD_CONTENTS}/${bc_idx}`,
  );
  return res.data.data;
};
